import React from 'react'

const Exchange = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/exchange',
  ...props
}) => (
  <svg height='20' width='20' viewBox='0 0 20 20' style={style} {...props}>
    <g fill='none' fillRule='evenodd'>
      <path
        d='M17 1.6H3A1.4 1.4 0 0 0 1.6 3v14A1.4 1.4 0 0 0 3 18.4h14a1.4 1.4 0 0 0 1.4-1.4V3A1.4 1.4 0 0 0 17 1.6z'
        stroke={primaryColor} />
      <path
        stroke={secondaryColor}
        strokeLinecap='square'
        d='M4.5 15.5l2.498-5.34 3.11 1.916 2.053-4.662 3.556-2.593' />
    </g>
  </svg>
)

export default Exchange
